import React, { useState, useEffect } from 'react';

const ModalEdicionMultiple = ({ 
  isOpen, 
  onClose, 
  productosFiltrados,
  skusData,
  onGuardar,
  guardando
}) => {
  const [productosEditados, setProductosEditados] = useState([]);
  const [busqueda, setBusqueda] = useState('');

  // Función para obtener el precio desde skusData (igual que obtenerDatosCompetencia)
  const obtenerPrecioDesdeSkusData = (productoId) => {
    if (!skusData || !productoId) return 0;
    
    const productoData = skusData.find(sku => sku.ID === productoId);
    
    if (productoData) {
      // Buscar el precio en diferentes formatos
      const precio = productoData.PRICE_DS || productoData.price_ds || productoData['PRICE_DS'] || 0;
      return precio;
    }
    
    return 0;
  };

  // Inicializar productos editados cuando se abre el modal
  useEffect(() => {
    if (isOpen && productosFiltrados) {
      console.log('📊 ModalEdicionMultiple - Inicializando con productos:', productosFiltrados.length);
      console.log('📊 ModalEdicionMultiple - skusData disponible:', !!skusData, skusData?.length);
      
      // Log del primer producto para ver TODAS sus propiedades
      if (productosFiltrados.length > 0) {
        console.log('📊 ModalEdicionMultiple - Primer producto - Todas las columnas:', Object.keys(productosFiltrados[0]));
        console.log('📊 ModalEdicionMultiple - Primer producto - Datos completos:', productosFiltrados[0]);
      }
      
      const productosConPrecio = productosFiltrados.map((producto, index) => {
        // Obtener el precio desde skusData (igual que las competencias)
        const precioDesdeSkusData = obtenerPrecioDesdeSkusData(producto.id);
        const precioActual = precioDesdeSkusData || producto.precio || 0;
        
        // Log detallado de los primeros 5 productos
        if (index < 5) {
          console.log(`📊 ModalEdicionMultiple - Producto ${producto.id} (${producto.nombre}):`, {
            'precio desde producto': producto.precio,
            'precio desde skusData': precioDesdeSkusData,
            'precio final': precioActual,
            tipoPrecio: typeof precioActual,
            categoria: producto.categoria,
            subcategoria: producto.subcategoria
          });
        }
        
        return {
          id: producto.id,
          nombre: producto.nombre,
          categoria: producto.categoria,
          subcategoria: producto.subcategoria,
          precio: precioActual,
          precioOriginal: precioActual
        };
      });
      
      console.log('📊 ModalEdicionMultiple - Productos procesados (primeros 3):', productosConPrecio.slice(0, 3));
      
      setProductosEditados(productosConPrecio);
      setBusqueda(''); // Limpiar búsqueda al abrir el modal
    }
  }, [isOpen, productosFiltrados, skusData]);

  const handlePrecioChange = (productoId, nuevoPrecio) => {
    setProductosEditados(prev => 
      prev.map(p => 
        p.id === productoId 
          ? { ...p, precio: nuevoPrecio }
          : p
      )
    );
  };

  // Filtrar productos según el término de búsqueda
  const productosFiltradosBusqueda = productosEditados.filter(producto => {
    if (!busqueda) return true;
    
    const terminoBusqueda = busqueda.toLowerCase();
    const nombreProducto = (producto.nombre || '').toLowerCase();
    const categoriaProducto = (producto.categoria || '').toLowerCase();
    const subcategoriaProducto = (producto.subcategoria || '').toLowerCase();
    
    return nombreProducto.includes(terminoBusqueda) ||
           categoriaProducto.includes(terminoBusqueda) ||
           subcategoriaProducto.includes(terminoBusqueda);
  });

  const handleGuardar = () => {
    // Obtener solo los productos que tienen cambios en el precio
    const productosModificados = productosEditados.filter(p => {
      const precioActual = parseFloat(p.precio) || 0;
      const precioOriginal = parseFloat(p.precioOriginal) || 0;
      return precioActual !== precioOriginal && p.precio !== '';
    });

    if (productosModificados.length === 0) {
      alert('No hay cambios para guardar');
      return;
    }

    // Preparar datos para enviar (solo id y precio)
    // El userUid se maneja en la función guardarEdicionMultiple del componente padre
    const cambios = productosModificados.map(p => ({
      id: p.id,
      precio: parseFloat(p.precio) || 0
    }));

    console.log(`📊 Enviando ${cambios.length} cambios de precio desde modal:`, cambios);

    onGuardar(cambios);
  };

  if (!isOpen) return null;

  return (
    <div 
      className="modal fade show" 
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} 
      onClick={onClose}
    >
      <div 
        className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-edit me-2"></i>
              Edición Múltiple de Precios
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              disabled={guardando}
            ></button>
          </div>
          
          <div className="modal-body">
            <div className="alert alert-info mb-3" role="alert">
              <i className="fas fa-info-circle me-2"></i>
              Modifique los precios en $ de los productos. Solo se guardarán los productos que tengan cambios.
            </div>

            {/* Buscador */}
            <div className="mb-3">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por SKU, categoría o subcategoría..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  disabled={guardando}
                />
                {busqueda && (
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setBusqueda('')}
                    disabled={guardando}
                    title="Limpiar búsqueda"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
              </div>
              {busqueda && (
                <small className="text-muted">
                  Mostrando {productosFiltradosBusqueda.length} de {productosEditados.length} productos
                </small>
              )}
            </div>

            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered">
                <thead className="table-light sticky-top">
                  <tr>
                    <th scope="col" style={{ width: '35%' }}>SKU</th>
                    <th scope="col" style={{ width: '20%' }}>Categoría</th>
                    <th scope="col" style={{ width: '20%' }}>Subcategoría</th>
                    <th scope="col" style={{ width: '25%' }}>Precio ($)</th>
                  </tr>
                </thead>
                <tbody>
                  {productosFiltradosBusqueda.length > 0 ? (
                    productosFiltradosBusqueda.map((producto) => (
                      <tr key={producto.id}>
                        <td>
                          <span className="text-break">{producto.nombre}</span>
                        </td>
                        <td>{producto.categoria || '-'}</td>
                        <td>{producto.subcategoria || '-'}</td>
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                            value={producto.precio}
                            onChange={(e) => handlePrecioChange(producto.id, e.target.value)}
                            disabled={guardando}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        <i className="fas fa-search fa-2x mb-2 d-block"></i>
                        No se encontraron productos que coincidan con "{busqueda}"
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {productosEditados.length === 0 && (
              <div className="text-center py-4">
                <i className="fas fa-box-open fa-2x text-muted mb-3"></i>
                <p className="text-muted">No hay productos para editar</p>
              </div>
            )}
          </div>
          
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={guardando}
            >
              Cancelar
            </button>
            <button 
              type="button" 
              className="btn btn-success"
              onClick={handleGuardar}
              disabled={guardando || productosEditados.length === 0}
            >
              {guardando ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Guardando...</span>
                  </div>
                  Guardando...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-2"></i>
                  Guardar cambios
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalEdicionMultiple;
